import useListLoader from '../base/useListLoader';

function responseToItems({ data }) {
  const { events = [], included = {} } = data;
  const { users } = included;

  return events.map((event) => {
    const user = users[event.attendee?.id] || {};

    return {
      ...event,
      user,
    };
  });
}

/**
 * Loads Grouped Calendar Events for Timeline from Teamwork v3 endpoints.
 */
export default function useCalendarEventsPlanningGroupedV3Loader({ params, count, pageSize = 50 }) {
  const { state, refresh } = useListLoader({
    url: '/projects/api/v3/calendars/events/planning/grouped.json',
    params,
    count,
    pageSize,
    responseToItems,
  });

  return { ...state, refresh };
}
